import React from "react"
import soldImage from "../../assets/img/sold_out.png"

function MerchandiseCard({ item }) {
  return (
    <div className="merchandise-card uk-card">
      <div
        className="uk-inline uk-cover-container uk-height-medium uk-card-media-top uk-width-1-1"
        style={{
          minWidth: 280
        }}
      >
        <img
          src={item.image}
          alt={item.name}
          className="uk-cover uk-margin-remove uk-height-1-1 uk-width-1-1"
        />
        {item.soldOut ? (
          <div className="uk-overlay-primary uk-position-cover">
            <img
              src={soldImage}
              alt="sold"
              className="merchandise-soldout uk-position-absolute uk-transform-center"
            />
          </div>
        ) : null}
      </div>
      <div className="merchandise-desc uk-flex uk-flex-column">
        <span className="merchandise-title uk-text-secondary uk-text-light">
          {item.name}
        </span>
        <div className="merchandise-size uk-margin-small-bottom uk-text-bold">
          {item.sizeS && <span>S</span>}
          {item.sizeM && <span>M</span>}
          {item.sizeL && <span>L</span>}
          {item.sizeXL && <span>XL</span>}
        </div>

        <div className="uk-text-right">
          <span className="merchandise-price uk-margin-top uk-text-secondary uk-text-bold">
            {`Rp. ${item.price.toLocaleString("id")}`}
          </span>
        </div>
      </div>
    </div>
  )
}

export default MerchandiseCard
